import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { useDispatch, useSelector } from "react-redux";
import { Button, Dialog, DialogTitle, FormControl, Grid, MenuItem, TextField, Toolbar, Typography } from "@material-ui/core";
import SaveIcon from "@material-ui/icons/Save";
import CancelIcon from '@material-ui/icons/Cancel';
import { ValidatorForm, SelectValidator } from "react-material-ui-form-validator";
import { AlertFinalizadoStepper } from "../../stepper/AlertFinalizadoStepper";
import { nuevoTurnoDemanda } from "../../../actions/turnos/agenda";
import { getTurnosCtaCtePorGrupo } from "../../../actions/turnos/ctaCte";
import { BuscadorParaTurnos } from "../../afiliaciones/BuscadorParaTurnos";

const useStyles = makeStyles((theme) => ({
    root: {
        marginLeft: "auto",
        marginRight: "auto",
        width: "80%",
    },
    header: {
        background: '#68389F',
        color: 'white'
    },
    formControl: {
        marginTop: 15,
        minWidth: 120,
        // marginLeft: 20,
        // margin: theme.spacing(1),
    },
    botonera: {
        marginTop: 50,
        marginLeft: 55,
        marginBottom: 20,
        paddingBottom: 13
    },
}));

const optionsfecha = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
};

const formatTime = time => {
    return time.toLocaleString('en-US', { minimumIntegerDigits: 2, useGrouping: false });
}

export const ModalAltaTurnoDemanda = (props) => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const { open, setOpen, fecha, horariosDemandaValidos, title } = props;
    const { seleccionado, afiliado } = useSelector((state) => state.afiliacion);
    const [openQuestion, setOpenQuestion] = useState(false);
    const [parametrizacionSeleccionada, setParametrizacionSeleccionada] = useState({});
    const { saldo = 0 } = useSelector((state) => state.ctaCte);

    const [idObraSocial, setIdObraSocial] = useState(null);

    const handleSave = () => {
        dispatch(nuevoTurnoDemanda(parametrizacionSeleccionada.idEfHorario, afiliado.id_afiliado, afiliado.carnet, fecha, parametrizacionSeleccionada.profesional.idEfectorRed, idObraSocial, afiliado.nro_doc, closeModal));
    }

    const closeModal = () => {
        setOpen(false);
        setOpenQuestion(false)
        setParametrizacionSeleccionada({})
    }
    const handleInputChange = (e) => {
        setParametrizacionSeleccionada(e.target.value);
    }

    useEffect(() => {
        if (seleccionado && afiliado.idGrupoFamiliar > 1)
            dispatch(getTurnosCtaCtePorGrupo(afiliado?.idGrupoFamiliar));
    }, [dispatch, afiliado?.idGrupoFamiliar]);

    useEffect(() => {
        if (horariosDemandaValidos.length === 1)
            setParametrizacionSeleccionada(horariosDemandaValidos[0]);
    }, [horariosDemandaValidos]);

    return (
        <Dialog
            maxWidth="md"
            fullWidth={true}
            open={open}
            onClose={closeModal}
        >
            <DialogTitle className={classes.header}>
                <Toolbar >
                    <Typography variant="h6" >
                        {title}
                    </Typography>
                </Toolbar>
            </DialogTitle>
            <ValidatorForm onSubmit={() => setOpenQuestion(true)}>
                <div className={classes.root}>
                    <Grid container>
                        <Grid item xs={12} sm={12} md={12} style={{marginLeft: '-10%'}}>
                            <BuscadorParaTurnos
                                consultaTurnos={true}
                                idObraSocial={idObraSocial}
                                setIdObraSocial={setIdObraSocial}
                                onModal={true}
                            />
                        </Grid>
                    </Grid>
                    <Grid container >
                        <Grid item xs={12} md={4} style={{ marginRight: 35 }} >
                            <TextField
                                margin="normal"
                                fullWidth={true}
                                disabled={true}
                                label="Fecha"
                                name="fecha"
                                value={new Date(fecha).toLocaleString(
                                    "es",
                                    optionsfecha
                                )}
                                autoComplete="off"
                            />
                        </Grid>
                        <Grid item xs={12} md={7} >
                            <FormControl
                                className={classes.formControl}
                                margin="normal"
                                fullWidth={true}
                            >
                                <SelectValidator
                                    label="Centro Médico / Especialidad / Horario"
                                    name="idEfHorario"
                                    fullWidth={true}
                                    value={parametrizacionSeleccionada}
                                    onChange={handleInputChange}
                                    validators={['required']}
                                    errorMessages={['Seleccione una opción']}
                                >
                                    {horariosDemandaValidos.map((item) => (
                                        <MenuItem key={item.idEfHorario} value={item}>
                                            {
                                                <span>{`${item.centroMedico.descripcionCentro}`}
                                                    {` / ${item.especialidad.descripcionEspecialidades}`}
                                                    {` / Horario: ${formatTime(item.horaDesde)} : ${formatTime(item.minDesde)}`}
                                                    {` a ${formatTime(item.horaHasta)} : ${formatTime(item.minHasta)}`}</span>
                                            }
                                        </MenuItem>
                                    ))}
                                </SelectValidator>
                            </FormControl>
                        </Grid>
                        {seleccionado &&
                            <Grid item xs={12}>
                                {saldo === 0 &&
                                    <Typography variant="h6" component="h2">
                                        <strong>Saldo en CtaCte: ${saldo.toFixed(2)}</strong>
                                    </Typography>}
                                {saldo < 0 &&
                                    <Typography variant="h6" component="h2" style={{ color: 'green' }}>
                                        <strong>Saldo en CtaCte: ${(saldo * -1).toFixed(2)}</strong>
                                    </Typography>}
                                {saldo > 0 &&
                                    <Typography variant="h6" component="h2" style={{ color: 'red' }}>
                                        <strong>Saldo en CtaCte Deuda: ${saldo.toFixed(2)}</strong>
                                    </Typography>}
                            </Grid>}
                    </Grid>
                    <Grid className={classes.botonera} container >
                        <Grid item xs={10}>
                            <Grid
                                container
                                direction="row"
                                justify="space-between"
                                alignItems="center"
                            >
                                <Button
                                    variant="contained"
                                    color="secondary"
                                    size="small"
                                    startIcon={<CancelIcon />}
                                    onClick={closeModal}
                                >
                                    CANCELAR
                                </Button>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    size="small"
                                    disabled={afiliado?.fecha_baja || !seleccionado || afiliado?.sinFichaAfiliacion}
                                    startIcon={<SaveIcon />}
                                    type="submit"
                                >
                                    CONFIRMAR
                                </Button>
                            </Grid>
                        </Grid>
                    </Grid>
                    {openQuestion &&
                        <AlertFinalizadoStepper
                            open={openQuestion}
                            pregunta={"Confirmación de turno por demanda"}
                            dialogText={`Se va a confirmar el turno por demanda del afiliado ${afiliado.apellido_y_nombre}
                                con el profesional ${parametrizacionSeleccionada.profesional.nombreEfector} está seguro?`}
                            buttonCancel={"Cancelar"}
                            buttonSubmit={"Continuar"}
                            handleClose={() => setOpenQuestion(false)}
                            handleSend={handleSave}
                        />
                    }
                </div>
            </ValidatorForm>
        </Dialog>
    );

};
